import KeenSlider from 'keen-slider'

window.addEventListener('DOMContentLoaded', () => {
	var slider = new KeenSlider('.five-keys .keen-slider', {
		breakpoints: {
			'(min-width: 512px)': {
				slides: {
					origin: 'center',
					perView: 1.6,
					spacing: 24,
				},
			},
			'(min-width: 768px)': {
				slides: {
					origin: 'center',
					perView: 2.2,
					spacing: 24,
				},
			},
			'(min-width: 992px)': {
				disabled: true,
			},
		},
		slides: {
			origin: 'center',
			perView: 1.1,
			spacing: 16,
		},
		loop: true,
		defaultAnimation: {
			duration: 800,
		},
	})
})
